import { components } from 'react-select'

import { Box, ICONS_NAME, IconV2 } from '../../../'

export const ClearIndicator = (
    props,
) => {
    const clearValue = () => {
        props.clearValue()
    }

    const innerProps = {
        ...props.innerProps,
        onMouseDown: clearValue,
    }

    return (
        <components.ClearIndicator {...props} innerProps={innerProps}>
            <Box cursor="pointer">
                <IconV2
                    name={ICONS_NAME.close}
                    color={
                        props.isFocused
                            ? props.theme.colors.danger
                            : props.theme.colors.neutral20
                    }
                    size={12}
                />
            </Box>
        </components.ClearIndicator>
    )
}
